import messages from './messages';

export const faqItems = [
	{
		question: messages.question1,
		answer: messages.answer1,
		url: 'https://support.calm.com/hc/en-us/articles/115002473607',
	},
	{
		question: messages.question2,
		answer: messages.answer2,
	},
	{
		question: messages.question3,
		answer: messages.answer3,
	},
	{
		question: messages.question4,
		answer: messages.answer4,
	},
];
